module.exports = __webpack_public_path__ + "img/search.61f8003d.svg";